import request from '@/utils/request'
//退货出库


// 获取出库状态
export function ckStatusList() {
    return request({
      method: 'get',
      url: "/yzdservice/api/enum/ck/ty"
    })
  }
//（下拉）查询购买入库编号
export function getGmrkXgxx() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/thck/getGmrkXgxx",
        timeout: 1000 * 60 * 2
    })
}
//获取经办人下拉
export function getJbrList() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/syck/getLyrList"
    })
}
//查询运输证，且分页
export function selectYszList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/thck/selectYszList",
        data:data
    })
}
//获取退货出库列表
export function postThckList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/thck/list",
        data:data
    })
}
//新增/编辑保存退货出库（暂时保存）
export function addOrUpdSaveTemp(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/thck/addOrUpdSaveTemp",
        data:data
    })
}
//新增/编辑保存退货出库（出库）
export function addOrUpdSave(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/thck/addOrUpdSave",
        data:data
    })
}
//获取退货出库详情
export function getThckDetail(id) {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/thck/detail/"+id
    })
}
//删除退货出库
export function delThckDetail(id) {
    return request({
        method: 'delete',
        url: "/yzdservice/enterprise/dwCk/thck/remove/"+id
    })
}
//退货出库导出
export function exportThck(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/thck/excelwriter",
        data:data,
        responseType: 'blob'
    })
}
//变更保存前校验库库存是否为负数
export function changePdkcByThck(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/thck/changePdkcByThck",
        data:data
    })
}
//变更保存前校验库库存是否为负数
export function saveChangeApply(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/thck/saveChangeApply",
        data:data
    })
}
